import React, {createContext, useState} from 'react';

export interface ErrorObject {
    error?: string,
    errorMessage?: string,
}

interface ErrorContextType {
    errorState: ErrorObject,
    setErrorState: (value: any) => void,
}

const ErrorContext = createContext<ErrorContextType>({
        errorState: {} as ErrorObject,
        setErrorState: () => {},
    },
);

const ErrorContextProvider = ({children}: any) => {
    const [errorState, setErrorState] = useState({});
    const contextValue = React.useMemo(() => ({ errorState, setErrorState }), [errorState, setErrorState]);
    return (
        <ErrorContext.Provider value={contextValue}>
            {children}
        </ErrorContext.Provider>
    );
};


export { ErrorContext, ErrorContextProvider };
